module.exports = __webpack_public_path__ + "img/588x310-01.10bc014f.png";